module.exports = __webpack_public_path__ + "static/img/speed-two.e96485b2.jpg";